import { computed } from '@vue/composition-api'
import { CompanyAPI, UserAPI } from '@/api/backend-client'
import { User } from '@/api/model/user'
import { Company } from '@/api/model/company'

const currentUser = computed<User | null>(() => {
    return UserAPI.reactiveCurrentUser.value
        ? UserAPI.reactiveCurrentUser.value as User
        : null
})

const currentCompany = computed<Company | null>(() => {
    return CompanyAPI.reactiveCurrentCompany.value
        ? CompanyAPI.reactiveCurrentCompany.value as Company
        : null
})

export function useCurrentData() {
    return {
        currentUser,
        currentCompany,
    }
}
